import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from 'react';

import {
  Container,
  Content,
  ComboProps,
  ComboLocalProps,
} from 'styles/sgo_wrappers';
import { useHistory, useLocation } from 'react-router-dom';

import SGOHeader from 'components/SGOHeader';
import SGONavbar from 'components/SGONavbar';
import ScrollTop from 'components/ScrollTop';
import SGOFooter from 'components/SGOFooter';
import Loading from 'components/Loading';
import SelectV2 from 'components/SelectV2';
import RadioContainer from 'components/RadioContainer';
import Checkbox from 'components/Checkbox';

import api from 'services/api';

import { useCredentials } from 'hooks/credentials';
import { useAuth } from 'hooks/auth';
import { useToast } from 'hooks/toast';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { useSpring } from 'react-spring';

import { useWindow } from 'hooks/window';
import { checkAddress } from 'utils/specialChars';
import {
  FaArrowLeft,
  FaPlusSquare,
  FaSortDown,
  FaSortUp,
  FaTimesCircle,
} from 'react-icons/fa';
import { calcTotal, formatNumber } from 'utils/calcTotal';
import { UpdateProps } from 'styles/dialog_update';
import * as U from 'styles/dialog_update';
import Textarea from 'components/Textarea';
import Button from 'components/Button';

import { alphaMasking } from 'components/Textarea/masks';

import {
  AddressWarn,
  StyledButtonPhaseOne,
  PhaseOne,
  PhaseTwo,
  PhaseThree,
  CoordContainer,
  ItemContainer,
  AddButton,
  InfoContainer,
  FinishButton,
  TotalRM,
  Grid,
  GridItem,
  DeclareNumbers,
  SpanMessage,
  DeclareButton,
  ReturnButton,
} from './styles';

interface CoordProps {
  cod: string;
  desc: string;
}

interface RMItemsProps {
  matcod: string;
  matdesc: string;
  cost: number;
  quantity: number;
  stored: number;
  require: boolean;
  numbers: string[];
  selected: string[];
}

const RMInsert: React.FC = () => {
  const phaseOne = useRef<FormHandles>(null);
  const phaseTwo = useRef<FormHandles>(null);
  const phaseThree = useRef<FormHandles>(null);
  const { pathname } = useLocation();
  const history = useHistory();
  const { user } = useAuth();
  const { width } = useWindow();
  const { addToast } = useToast();
  const { errorHandling, handlePermission } = useCredentials();
  const [loading, setLoading] = useState(false);

  const [comboLocs, setComboLocs] = useState<ComboProps[]>([]);
  const [comboNacs, setComboNacs] = useState<ComboProps[]>([]);
  const [mats, setMats] = useState<ComboProps[]>([]);

  const [storageQuantity, setStorageQuantity] = useState('-');
  const [cost, setCost] = useState(0);
  const [possibleNumbers, setPossibleNumbers] = useState<string[]>([]);
  const [isRequired, setIsRequired] = useState(false);
  const [rmItems, setrmItems] = useState<RMItemsProps[]>([]);

  const [isPhaseOne, setIsPhaseOne] = useState(true);
  const [isPhaseTwo, setIsPhaseTwo] = useState(false);
  const [isPhaseThree, setIsPhaseThree] = useState(false);

  const [type, setType] = useState('L');
  const [coordSelected, setCoordSelected] = useState<CoordProps>(
    {} as CoordProps,
  );
  const [deliverAddress, setDeliverAddress] = useState('');
  const [deliverAble, setDeliverAble] = useState(false);
  const [addressWarn, setAddressWarn] = useState('');

  const [pAddress, setPAddress] = useState('');
  const [sAddress, setSAddress] = useState('');

  const [updateDiag, setUpdateDiag] = useState<UpdateProps>({
    open: false,
    content: '',
    values: {},
  });

  const totalRM = useMemo(() => {
    const total = rmItems.reduce(
      (accum, { quantity, cost: value }: RMItemsProps) => {
        const semitotal = accum + quantity * value;
        return semitotal;
      },
      0,
    );

    return total;
  }, [rmItems]);

  const faulty = useMemo(() => {
    const total = rmItems.reduce(
      (accum, { quantity, selected, require }: RMItemsProps) => {
        return require
          ? quantity === selected.length
            ? accum
            : accum + 1
          : accum;
      },
      0,
    );

    return total;
  }, [rmItems]);

  const getComboLOC = useCallback(async () => {
    try {
      const response = await api.get(
        `/combos/comboLOCs.php?data=${JSON.stringify({ filterStat: true })}`,
      );

      if (['NAC'].indexOf(user.perfil) > -1) {
        setComboLocs(
          response.data.filter(
            (item: ComboLocalProps) => item.anb === user.anbc,
          ),
        );
      }
    } catch (err) {
      errorHandling(err);
    }
  }, [user.perfil, user.anbc, errorHandling]);

  const getComboANB = useCallback(async () => {
    const response = await api.get('/combos/comboANBs.php');
    const filtered: ComboProps[] = response.data.filter(
      (item: ComboProps) => item.value !== user.anbc,
    );

    const sameZon = filtered
      .filter(
        (item: ComboProps) =>
          item.value.substr(0, 2) === user.zoncod.substr(0, 2),
      )
      .sort((a, b) => a.value.localeCompare(b.value));

    const otherZon = filtered
      .filter(
        (item: ComboProps) =>
          item.value.substr(0, 2) !== user.zoncod.substr(0, 2),
      )
      .sort((a, b) => a.value.localeCompare(b.value));

    setComboNacs([...sameZon, ...otherZon]);
  }, [user.anbc, user.zoncod]);

  const phaseOneStyled = useSpring({
    opacity: isPhaseOne ? 1 : 0,
    transform: isPhaseOne ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseOne ? 'all' : 'none',
    display: isPhaseOne ? 'inline' : 'none',
  });
  const phaseTwoStyled = useSpring({
    opacity: isPhaseTwo ? 1 : 0,
    transform: isPhaseTwo ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseTwo ? 'all' : 'none',
    display: isPhaseTwo ? 'inline' : 'none',
  });
  const phaseThreeStyled = useSpring({
    opacity: isPhaseThree ? 1 : 0,
    transform: isPhaseThree ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseThree ? 'all' : 'none',
    display: isPhaseThree ? 'inline' : 'none',
  });
  const phaseOneProceedButton = useSpring({
    opacity: coordSelected.cod ? 1 : 0,
    transform: coordSelected.cod ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: coordSelected.cod ? 'all' : 'none',
    // display: coordSelected.cod ? 'inline' : 'none',
  });
  const phaseTwoProceedButton = useSpring({
    transform:
      rmItems.length > 0 && faulty === 0
        ? 'translateX(5px)'
        : 'translateX(60px)',
    opacity: rmItems.length > 0 && faulty === 0 ? 1 : 0,
    pointerEvents: rmItems.length > 0 && faulty === 0 ? 'all' : 'none',
  });
  const warnStyle = useSpring({
    opacity: addressWarn.length > 0 ? 1 : 0,
    height: addressWarn.length > 0 ? (width <= 500 ? '58px' : '30px') : '0px',
  });

  const toggleFlexDirection = useSpring({
    flexDirection: width < 400 && totalRM > 99.99 ? 'column' : 'row',
  });

  useEffect(() => {
    handlePermission(['NAC'], true);
    getComboLOC();
    getComboANB();
  }, [handlePermission, getComboLOC, getComboANB]);

  const handleRadioClick = useCallback(() => {
    setCoordSelected({} as CoordProps);
    setType(phaseOne.current?.getFieldValue('destiny'));
  }, []);

  const handleCoordSelected = useCallback(() => {
    const code = phaseOne.current?.getFieldValue('coord');
    const group = type === 'L' ? comboLocs : comboNacs;

    setCoordSelected({
      cod: code,
      desc:
        group[group.findIndex((item: ComboProps) => item.value === code)].label,
    });
  }, [comboLocs, comboNacs, type]);

  const handleAddressRadioClick = useCallback(() => {
    const value = phaseThree.current?.getFieldValue('deliver');

    setDeliverAddress(value === 'P' ? pAddress : sAddress);
  }, [pAddress, sAddress]);

  const getAddress = useCallback(async () => {
    try {
      const response = await api.get<{ END1: string; END2: string }>(
        `/sgo/getAddress.php?data=${JSON.stringify({
          trans: 'rm',
          type,
          cod: coordSelected.cod,
        })}`,
      );

      const { END1, END2 } = response.data;

      if (END1 && END2) {
        if (checkAddress(END1) === checkAddress(END2)) {
          setDeliverAddress(END1);
        } else {
          setDeliverAble(true);
          setDeliverAddress(END1);
          setPAddress(END1);
          setSAddress(END2);
          phaseThree.current?.setFieldValue('deliver', 'P');
        }
      } else if (!END1 && END2) {
        setDeliverAddress(END2);
      } else if (!END2 && END1) {
        setDeliverAddress(END1);
      } else {
        setAddressWarn(
          'Esta coordenação não atende os requisitos de endereço de entrega.',
        );
      }
    } catch (err) {
      errorHandling(err);
    }
  }, [coordSelected.cod, errorHandling, type]);

  const getComboMATS = useCallback(async () => {
    try {
      const response = await api.get('/combos/comboMATs.php?from=rm');
      setMats(response.data);
    } catch (err) {
      errorHandling(err);
    }
  }, [errorHandling]);

  const handleProceedPhaseTwo = useCallback(() => {
    setIsPhaseOne(false);
    setIsPhaseTwo(true);
    getComboMATS();
    getAddress();
  }, [getAddress, getComboMATS]);

  const handleMaterialSelect = useCallback(async () => {
    try {
      setLoading(true);
      phaseTwo.current?.setErrors({});
      const material = phaseTwo.current?.getFieldValue('material');

      const send = JSON.stringify({
        matcod: material,
        trans: 'rm',
        type,
      });
      const response = await api.get(`/sgo/getStorage.php?data=${send}`);

      const { quantity, matcost, numbers, requireNum } = response.data;

      if (requireNum) {
        setPossibleNumbers(numbers);
      }

      setIsRequired(requireNum);
      setStorageQuantity(quantity);
      setCost(matcost);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [errorHandling, type]);

  const handlePushMaterial = useCallback(() => {
    const index = mats.findIndex(
      (item: ComboProps) =>
        item.value === phaseTwo.current?.getFieldValue('material'),
    );

    phaseTwo.current?.setErrors({});

    if (parseInt(storageQuantity, 10) === 0) {
      addToast({
        type: 'info',
        title: `Este material não possui estoque`,
        description: 'Não é possível adicioná-lo',
      });
      return;
    }
    if (index > -1) {
      const newMat = {
        matcod: mats[index].value,
        matdesc: mats[index].label,
        cost,
        quantity: 1,
        stored: parseInt(storageQuantity, 10),
        require: isRequired,
        numbers: possibleNumbers,
        selected: [],
      };

      setrmItems((state) => [newMat, ...state]);
      setMats((state) =>
        state.filter((item: ComboProps) => item.value !== newMat.matcod),
      );
      setStorageQuantity('-');
      setCost(0);
      setIsRequired(false);
      setPossibleNumbers([]);
    } else {
      phaseTwo.current?.setFieldError(
        'material',
        'You must select at least one material',
      );

      addToast({
        type: 'info',
        title: ``,
        description: 'É necessário escolher um material.',
      });
    }

    phaseTwo.current?.setFieldValue('material', '');
  }, [addToast, cost, isRequired, mats, possibleNumbers, storageQuantity]);

  const handleAdd = useCallback(
    (material: string) => {
      const index = rmItems.findIndex(
        (item: RMItemsProps) => item.matcod === material,
      );

      if (index > -1) {
        rmItems[index].quantity += 1;
        setrmItems((state) => [...state]);
      }
    },
    [rmItems],
  );

  const handleSub = useCallback(
    (material: string) => {
      const index = rmItems.findIndex(
        (item: RMItemsProps) => item.matcod === material,
      );

      if (index > -1) {
        rmItems[index].quantity -= 1;
        setrmItems((state) =>
          rmItems[index].quantity === 0
            ? [...state].filter(
                (item: RMItemsProps) => item.matcod !== rmItems[index].matcod,
              )
            : [...state],
        );

        if (rmItems[index].quantity === 0) {
          const reinsert = {
            value: rmItems[index].matcod,
            label: rmItems[index].matdesc,
          };

          const rearrange = [...mats, reinsert].sort((a, b) =>
            a.label > b.label ? 1 : -1,
          );

          setMats(rearrange);
        }
      }
    },
    [rmItems, mats],
  );

  const handleInputChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>, mat: string) => {
      const index = rmItems.findIndex(
        (item: RMItemsProps) => item.matcod === mat,
      );
      const number = e.currentTarget.value.replace(/^0/, '');
      if (number.length > 0) {
        const asNum = parseInt(number, 10);

        if (index > -1) {
          rmItems[index].quantity = asNum;
          setrmItems((state) =>
            rmItems[index].quantity <= 0
              ? [...state].filter(
                  (item: RMItemsProps) => item.matcod !== rmItems[index].matcod,
                )
              : [...state],
          );
        }
      } else {
        rmItems[index].quantity = 0;
        setrmItems((state) => [...state]);
      }

      e.currentTarget.value = e.currentTarget.value.replace(/^0/, '');
    },
    [rmItems],
  );

  const handleInputBlur = useCallback(
    (e: React.FormEvent<HTMLInputElement>, mat: string) => {
      const index = rmItems.findIndex(
        (item: RMItemsProps) => item.matcod === mat,
      );
      if (e.currentTarget.value === '0') {
        setrmItems((state) =>
          [...state].filter(
            (item: RMItemsProps) => item.matcod !== rmItems[index].matcod,
          ),
        );

        const material = {
          value: rmItems[index].matcod,
          label: rmItems[index].matdesc,
        };

        const rearrange = [...mats, material].sort((a, b) =>
          a.label > b.label ? 1 : -1,
        );

        setMats(rearrange);
        return;
      }

      if (parseInt(e.currentTarget.value, 10) > rmItems[index].stored) {
        rmItems[index].quantity = rmItems[index].stored;
        setrmItems((state) => [...state]);
      }
    },
    [rmItems, mats],
  );

  const handleRemoveItem = useCallback(
    (mat: string) => {
      const index = rmItems.findIndex(
        (item: RMItemsProps) => item.matcod === mat,
      );

      const reinsert = {
        value: rmItems[index].matcod,
        label: rmItems[index].matdesc,
      };

      setrmItems((state) =>
        state.filter((item: RMItemsProps) => item.matcod !== mat),
      );

      const rearrange = [...mats, reinsert].sort((a, b) =>
        a.label > b.label ? 1 : -1,
      );

      setMats(rearrange);
    },
    [mats, rmItems],
  );

  const handleDeclareClick = useCallback(
    (matcod: string, number: string) => {
      const index = rmItems.findIndex(
        (item: RMItemsProps) => item.matcod === matcod,
      );

      const exists = [...rmItems[index].selected].includes(number);

      rmItems[index].selected = exists
        ? [...rmItems[index].selected].filter((item: string) => item !== number)
        : [...rmItems[index].selected, number];

      setrmItems((state) => [...state]);
    },
    [rmItems],
  );

  const handleOBSChange = useCallback(
    (e: React.FormEvent<HTMLTextAreaElement>) => {
      const newstring = e;
      alphaMasking(newstring);

      return newstring;
    },
    [],
  );

  const handleFinish = useCallback(async () => {
    try {
      setLoading(true);

      const data = {
        dest: coordSelected,
        items: rmItems,
        address: {
          value: phaseThree.current?.getFieldValue('deliver') || 'P',
          label: deliverAddress,
        },
        obs: phaseThree.current?.getFieldValue('obs').replace('#', ''),
        name: user.name,
        anbdesc: user.anbdesc,
        totalRM,
        type,
      };

      const send = new FormData();
      send.append('data', JSON.stringify(data));

      const response = await api.post('/sgo/rm_insert.php', send, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const { rmnum } = response.data;
      addToast({
        type: 'success',
        title: 'Sucesso!',
        description: `Remessa de Material N° ${rmnum} emitida para a Coordenação ${coordSelected.desc}.`,
      });

      history.replace(pathname.replace('/insert', ''));
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [
    addToast,
    coordSelected,
    deliverAddress,
    errorHandling,
    history,
    pathname,
    rmItems,
    totalRM,
    type,
    user.anbdesc,
    user.name,
  ]);

  return (
    <Container>
      <Loading isLoading={loading} />
      <ScrollTop />
      <SGOHeader />
      <SGONavbar noLinks title="Remessa de Material" />
      <Content>
        <AddressWarn style={warnStyle}>
          <h4>{addressWarn}</h4>
        </AddressWarn>
        <PhaseOne style={phaseOneStyled}>
          <Form translate={undefined}
            ref={phaseOne}
            onSubmit={() => {
              return null;
            }}
          >
            <span>
              <RadioContainer
                title="Remessa de Material para: "
                onClick={handleRadioClick}
                name="destiny"
                content={[
                  {
                    id: 'lD',
                    value: 'L',
                    label: 'Local',
                  },
                  {
                    id: 'nD',
                    value: 'N',
                    label: 'Nacional',
                  },
                ]}
                itemsStyle={{
                  flexDirection: 'row',
                }}
                selected="L"
              />
            </span>
            <span>
              <p>Selecione a coordenação:</p>
              <SelectV2
                name="coord"
                initial="Selecione"
                content={type === 'L' ? comboLocs : comboNacs}
                onChange={handleCoordSelected}
              />
            </span>
          </Form>
          <StyledButtonPhaseOne
            onClick={handleProceedPhaseTwo}
            style={phaseOneProceedButton}
            bgcolor="#00802b"
          >
            Avançar
          </StyledButtonPhaseOne>
        </PhaseOne>
        <PhaseTwo style={phaseTwoStyled}>
          <Form translate={undefined}
            ref={phaseTwo}
            onSubmit={() => {
              return null;
            }}
          >
            <CoordContainer>
              <p>
                Coordenação: <strong>{coordSelected.desc}</strong>
              </p>
            </CoordContainer>
            <ItemContainer>
              <span>
                <SelectV2
                  name="material"
                  content={mats}
                  initial="Selecione"
                  onChange={handleMaterialSelect}
                />
              </span>
              <span>
                <p>Seu estoque:</p>
                <strong>{storageQuantity}</strong>
              </span>
            </ItemContainer>
            <AddButton as="button" type="button" onClick={handlePushMaterial}>
              <FaPlusSquare /> <p>Adicionar material</p>
            </AddButton>
            <InfoContainer>
              <TotalRM style={toggleFlexDirection}>
                <p>Total desta remessa:&nbsp;</p>
                <strong>R$ {formatNumber(totalRM)}</strong>
              </TotalRM>

              <FinishButton
                style={phaseTwoProceedButton}
                type="button"
                onClick={() => {
                  setIsPhaseTwo(false);
                  setIsPhaseThree(true);
                }}
              >
                Avançar
              </FinishButton>
            </InfoContainer>
            <Grid>
              {rmItems.map((item: RMItemsProps) => (
                <GridItem
                key={item.matcod}
                  $required={item.require}
                  $color={
                    item.selected.length < item.quantity
                      ? '#fda50f'
                      : item.selected.length === item.quantity
                      ? '#267326'
                      : '#c53030'
                  }
                >
                  <div>
                    <strong>
                      {item.matcod} - {item.matdesc}
                    </strong>
                  </div>
                  <div>
                    <span>
                      <p>
                        Custo:&nbsp;
                        <strong>R$ {formatNumber(item.cost)}</strong>
                      </p>
                    </span>
                    <span>
                      <p>Quantidade:</p>
                      <span>
                        <FaSortUp
                          onClick={() => handleAdd(item.matcod)}
                          style={{
                            transform: 'translateY(10px)',
                            color: '#009933',
                            opacity: item.stored > item.quantity ? 1 : 0,
                            pointerEvents:
                              item.stored > item.quantity ? 'all' : 'none',
                          }}
                        />

                        <input
                          type="number"
                          min={0}
                          value={item.quantity}
                          onChange={(e: React.FormEvent<HTMLInputElement>) =>
                            handleInputChange(e, item.matcod)
                          }
                          onBlur={(e: React.FormEvent<HTMLInputElement>) =>
                            handleInputBlur(e, item.matcod)
                          }
                        />

                        <FaSortDown
                          onClick={() => handleSub(item.matcod)}
                          style={{
                            transform: 'translateY(-10px)',
                            color: '#c53030',
                          }}
                        />
                      </span>
                      <figure>
                        <FaTimesCircle
                          onClick={() => handleRemoveItem(item.matcod)}
                        />
                      </figure>
                    </span>
                  </div>
                  <div>
                    <span>
                      <p>
                        Seu estoque atual:&nbsp;
                        <strong>{item.stored}</strong>
                      </p>
                    </span>
                  </div>
                  <div>
                    <span>
                      <p>
                        Total:&nbsp;
                        <strong>
                          R$ {calcTotal(item.quantity, item.cost)}
                        </strong>
                      </p>
                    </span>
                  </div>
                  {item.require && (
                    <>
                      <SpanMessage
                        $color={
                          item.selected.length < item.quantity
                            ? '#fda50f'
                            : item.selected.length === item.quantity
                            ? '#267326'
                            : '#c53030'
                        }
                      >
                        <p>
                          {item.selected.length === 0
                            ? 'É necessário selecionar os números controlados'
                            : item.selected.length < item.quantity
                            ? 'Quantidade selecionada é inferior a quantidade apontada'
                            : item.selected.length > item.quantity
                            ? 'Quantidade selecionada excede a quantidade apontada'
                            : ''}
                        </p>
                      </SpanMessage>
                      <div>
                        <span>
                          <DeclareButton as="button"
                            type="button"
                            onClick={() =>
                              setUpdateDiag({
                                open: true,
                                content: (
                                  <DeclareNumbers>
                                    {item.numbers.map((number: string) => (
                                      <Checkbox
                                        id={`N${number}`}
                                        title={number}
                                        onClick={() =>
                                          handleDeclareClick(
                                            item.matcod,
                                            number,
                                          )
                                        }
                                        checked={[...item.selected].includes(
                                          number,
                                        )}
                                      />
                                    ))}
                                  </DeclareNumbers>
                                ),
                                values: {
                                  matcod: item.matcod,
                                  matdesc: item.matdesc,
                                  max: item.quantity,
                                },
                              })
                            }
                          >
                            Selecionar numeração controlada
                          </DeclareButton>
                        </span>
                      </div>
                    </>
                  )}
                </GridItem>
              ))}
            </Grid>
          </Form>
        </PhaseTwo>
        <PhaseThree style={phaseThreeStyled}>
          <ReturnButton
            onClick={() => {
              setIsPhaseTwo(true);
              setIsPhaseThree(false);
            }}
          >
            <FaArrowLeft />
            <p>Retornar aos itens</p>
          </ReturnButton>
          <Form translate={undefined} ref={phaseThree} onSubmit={() => null}>
            <div>
              {deliverAble && (
                <RadioContainer
                  title="Endereço de Entrega:"
                  onClick={handleAddressRadioClick}
                  name="deliver"
                  content={[
                    {
                      id: 'dT',
                      value: 'P',
                      label:
                        type === 'L' ? 'Tesoureiro' : 'Escritório Nacional',
                    },
                    {
                      id: 'dL',
                      value: 'S',
                      label: type === 'L' ? 'Local' : 'Endereço Alternativo',
                    },
                  ]}
                  selected="P"
                />
              )}

              <p>{deliverAddress}</p>
            </div>
            <div>
              <p>Observação:</p>
              <Textarea
                name="obs"
                placeholder="Insira a observação (opcional)"
                onChange={(e: React.FormEvent<HTMLTextAreaElement>) =>
                  handleOBSChange(e)
                }
              />
            </div>
          </Form>
          {addressWarn.length <= 0 && (
            <Button onClick={handleFinish} bgcolor="#00802b">
              Finalizar
            </Button>
          )}
        </PhaseThree>

        <U.Container scroll="paper" maxWidth={false} open={updateDiag.open}>
          <U.Title>
            <h2>{updateDiag.values?.matdesc || 'Material'}</h2>
          </U.Title>
          <U.Content>{updateDiag.content}</U.Content>
          <U.Actions>
            {/* <U.Cancel as="button"
              type="button"
              onClick={() => setUpdateDiag({ open: false })}
            >
              Cancelar
            </U.Cancel> */}
            <U.Confirm as="button"
              type="button"
              onClick={() => setUpdateDiag({ open: false })}
            >
              Confirmar
            </U.Confirm>
          </U.Actions>
        </U.Container>
      </Content>
      <SGOFooter />
    </Container>
  );
};

export default RMInsert;
